<template>
  <div
    role="dialog"
    class="j-modal"
    style="--padding-left: 0px; --padding-right: -17px"
    @click="closeStoryModal"
  >
    <div @click.stop class="product-modal storyUpload">
      <div class="storyUploaderForm">
        <div class="formTopnav">
          <h2 class="formTitle">ثبت استوری</h2>
          <div class="closeBtn" @click="closeStoryModal">
            <i class="fa-solid fa-xmark"></i>
          </div>
        </div>
        <div class="formInputContainer">
          <div class="uploadInput">
            <input
              type="file"
              id="imageUpload"
              accept="image/*, video/*"
              @change="handleFileChange"
            />
            <div v-if="front_show.file == ''" class="customInput">
              <div class="inputPlaceholder">
                <div class="placeholderPhoto">
                  <svg
                    viewBox="0 0 120 120"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="120" height="120" fill="#fff" />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M33.2503 38.4816C33.2603 37.0472 34.4199 35.8864 35.8543 35.875H83.1463C84.5848 35.875 85.7503 37.0431 85.7503 38.4816V80.5184C85.7403 81.9528 84.5807 83.1136 83.1463 83.125H35.8543C34.4158 83.1236 33.2503 81.957 33.2503 80.5184V38.4816ZM80.5006 41.1251H38.5006V77.8751L62.8921 53.4783C63.9172 52.4536 65.5788 52.4536 66.6039 53.4783L80.5006 67.4013V41.1251ZM43.75 51.6249C43.75 54.5244 46.1005 56.8749 49 56.8749C51.8995 56.8749 54.25 54.5244 54.25 51.6249C54.25 48.7254 51.8995 46.3749 49 46.3749C46.1005 46.3749 43.75 48.7254 43.75 51.6249Z"
                      fill="#0096c7"
                    />
                  </svg>
                </div>
                <div class="placeholderText">تصویر یا ویدیو رو آپلود کن</div>
              </div>
            </div>
            <div v-if="front_show.file != ''" class="storyImagePreview">
              <img
                v-if="front_show.type == 'image'"
                :src="front_show.file"
                alt=""
              />
              <video v-if="front_show.type == 'video'">
                <source :src="front_show.file" alt="" type="video/mp4" />
              </video>
              <div class="imageDeleteBtn" @click="imageRemove()">
                <i class="fa-solid fa-trash"></i>
              </div>
              <div class="imageEditBtn" @click="setEditIndex()">
                <i class="fa-solid fa-pen"></i>
              </div>
            </div>
          </div>
          <div class="titleInput">
            <p>مدت زمان استوری</p>
            <div class="storyOpions">
              <div
                class="optionThumb"
                :class="{ active: post_filds.expire_type == '24' }"
                @click="expireTypeHandler('24')"
              >
                24 ساعت
              </div>
              <div
                class="optionThumb"
                :class="{ active: post_filds.expire_type == '48' }"
                @click="expireTypeHandler('48')"
              >
                48 ساعت
              </div>
              <div
                class="optionThumb"
                :class="{ active: post_filds.expire_type == '72' }"
                @click="expireTypeHandler('72')"
              >
                72 ساعت
              </div>
              <div
                class="optionThumb"
                :class="{ active: post_filds.expire_type == 'week' }"
                @click="expireTypeHandler('week')"
              >
                یک هفته
              </div>
            </div>
          </div>
          <div class="titleInput">
            <p>عنوان استوری</p>
            <textarea v-model="post_filds.title" rows="2"></textarea>
          </div>
          <div class="titleInput">
            <p>فایل مورد نظر را انتخاب کنید</p>
            <el-select
              filterable
              v-model="post_filds.post_id"
              popper-class="custom-dropdown"
              :fit-input-width="false"
            >
              <el-option value="0" label="انتخاب فایل"></el-option>
              <el-option
                v-for="(v, i) in post_list"
                :key="i"
                :value="v.id"
                :label="v.content"
              >
                <span class="elSelectListLabel">{{
                  v.content + "-" + v.address
                }}</span></el-option
              >
            </el-select>
          </div>
        </div>
        <div class="storySubmitBtn" v-if="!btn_loading" @click="save_story()">
          ثبت
        </div>
        <div class="storySubmitBtn" v-if="btn_loading">
          <span class="loader"></span>
        </div>
      </div>
    </div>
    <div class="j-modal__overly"></div>
  </div>
</template>

<script>
import "@majidh1/jalalidatepicker/dist/jalalidatepicker.min.css";
import "@majidh1/jalalidatepicker";
// import Compressor from "compressorjs";
import { toast } from "vue3-toastify";
import axios from "axios";

export default {
  name: "NewStory",

  props: {
    BranchInfos: Object,
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      color: "",
      divTop: "0",
      widthTop: "100%",
      dynamicStyles:
        "height: 0; overflow: hidden; transition: height 0.3s ease;",
      fillter: {
        main_category: "all",
        category: "all", //commercial
        text: "",
        location: "",
        min_width: 0,
        max_width: 0,
        min_price: 0,
        max_price: 0,
        min_rent_price: 0,
        max_rent_price: 0,
        min_mortageprice: 0,
        max_mortageprice: 0,
        bed: -1,
        min_age: 0,
        max_age: 0,
        min_floor: "0",
        max_floor: "0",
        min_totalFloor: "0",
        max_totalFloor: "0",
        min_Floorunit: "0",
        max_Floorunit: "0",
        docType: "0",
        advertiser: "all",
        district: "0",
        order_by: "newest",
        view_mode: "list",
        user_id: 0,
        city: 0,
        m_id: 0,
        per_page: "get",
        date: "",
        role: "branch_admin",
        consultant: 0,
        status: "approved",
        list_type: "own_profile",
      },
      post_list: [],
      front_show: {
        file: "",
        type: "",
      },
      post_filds: {
        file: "",
        title: "",
        post_id: "0",
        expire_type: "",
      },
      btn_loading: false,
      editIndex: null,
      branchInfo: null,
    };
  },
  watch: {
    showFile(newValue) {
      document.body.style.overflow = newValue ? "hidden" : "auto";
    },
  },
  mounted() {
    const bInfo = localStorage.getItem("branchinof");
    if (bInfo) {
      this.branchInfo = bInfo;
    }
    setInterval(() => {
      this.loadTheme();
    }, 100);

    this.load_post();

    window.jalaliDatepicker.startWatch({
      maxDate: "today",
    });
  },
  beforeUnmount() {
    // نیازی به حذف رویداد اسکرول نیست
  },
  methods: {
    expireTypeHandler(type) {
      this.post_filds.expire_type = type;
    },
    closeStoryModal() {
      this.$emit("close");
      this.front_show.file = [];
      this.front_show.type = [];
      this.post_filds.file = [];
      this.post_filds.title = "";
      this.post_filds.post_id = "0";
      document.body.style = "overflow: auto;";
    },
    handleFileChange(event) {
      let self = this;
      const files = event.target.files;

      const file = files[0];

      if (!file) return;

      const fileType = file.type.split("/")[0];
      this.front_show.type = fileType;

      const reader = new FileReader();

      reader.onload = (e) => {
        self.front_show.file = e.target.result;
      };

      reader.readAsDataURL(file);

      self.post_filds.file = file;

      event.target.value = "";
    },
    imageRemove() {
      this.front_show.type = "";
      this.front_show.file = "";
      this.post_filds.file = "";
    },
    setEditIndex() {
      const input = document.getElementById("imageUpload");
      input.click();
    },
    load_post() {
      this.fillter.branch_id = this.BranchInfos.id;
      if (
        this.$store.state.auth.role == "branch_admin" ||
        this.$store.state.auth.role == "consultant"
      ) {
        const bInfo = JSON.parse(localStorage.getItem("branchinof"));
        this.fillter.branch_id = bInfo ? bInfo.id : null;
        this.fillter.user_id = this.$store.state.auth.uid;
      }
      this.helperPost("post-list", this.fillter).then((r) => {
        if (r.data.result == 0) {
          this.post_list = [];
        } else {
          this.post_list = r.data.data.list;
        }
      });
    },

    save_story() {
      var self = this;
      if (
        this.$store.state.auth.loggedIn &&
        !this.$store.state.auth.is_complate
      ) {
        toast("برای ثبت استوری اطلاعات پروفایل خود را تکمیل کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }
      if (
        this.$store.state.auth.loggedIn &&
        this.branchInfo.is_allowed == "no"
      ) {
        toast(
          "پروفایل شما تکمیل شده است، اما برای ثبت استوری نیاز است هویت شما تایید شود.",
          {
            type: "error",
          },
        );
        return;
      }
      if (self.post_filds.file == "") {
        toast("فایلی بارگذاری نشده است", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }

      self.post_filds.branch_id = self.BranchInfos.id;
      self.post_filds.type = self.front_show.type;
      self.btn_loading = true;
      let axiosURL = "";
      if (this.post_filds.expire_type == "24") {
        axiosURL = "/save-story";
      } else if (this.post_filds.expire_type == "48") {
        axiosURL = "/save-storyy";
      } else if (this.post_filds.expire_type == "72") {
        axiosURL = "/save-storyyy";
      } else {
        axiosURL = "/save-storyyyy";
      }

      axios
        .post(self.$store.getters.baseUrl + axiosURL, self.post_filds, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + self.$store.getters.appToken,
          },
        })
        .then(function (r) {
          if (r.data.result == "success") {
            toast(r.data.msg, {
              type: "success",
            });
            setTimeout(() => {
              self.closeStoryModal();
            }, 1000);
          } else {
            toast(r.data.msg, {
              type: "error",
            });
          }
          self.btn_loading = false;
        })
        .catch(function (error) {
          self.btn_loading = false;
          toast(error, {
            type: "error",
          });
        });
    },

    loadTheme() {
      const width = window.innerWidth;
      this.color = width >= 1250 ? "#2dc653" : "#f5f5f5";
    },
  },
};
</script>

<style lang="scss" scoped>
.topNav__searchbar_wrapper {
  width: 60% !important;
}
.loadButtonarea {
  width: 100%;
  margin-top: 36px;
}
.loadButtonarea .loadButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 48px;
  text-align: center;
  background: #2dc653;
  font-family: "iranyekanB", sans-serif;
  font-size: 0.9rem;
  color: #fff;
  border-radius: 8px;
  margin: 0 auto;
}
.loader {
  height: 24px;
  width: 24px;
  margin-top: 0 !important;
}

.storyUploaderForm {
  width: 90%;
  max-width: 412px;
  min-width: 368px;
  padding: 24px 0;
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);

  .formTopnav {
    position: relative;
    width: 90%;
    padding-bottom: 16px;
    margin: 0 auto;

    .formTitle {
      font-family: "iranyekanB", sans-serif;
      font-size: 22px;
      text-align: center;
      color: #000;
    }

    .closeBtn {
      position: absolute;
      top: 0;
      left: 0;
      width: 36px;
      height: 36px;
      background: #ededed;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: #000;
      cursor: pointer;
    }
  }

  .formInputContainer {
    width: 90%;
    margin: 0 auto;

    .uploadInput {
      position: relative;
      width: 100%;
      margin: 16px 0 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      input {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        opacity: 0;
        cursor: pointer;
      }

      .storyImagePreview {
        position: relative;
        display: inline-block;
        margin: 0 auto;
        min-width: 132px;
        height: 132px;
        padding: 8px;
        border: 1px solid #0096c7;
        border-radius: 6px;
        background: rgba(0, 0, 0, 0.1);

        img,
        video {
          position: relative;
          max-width: 100%;
          height: 90%;
          object-fit: contain;
          overflow: hidden;
          border-radius: 6px;
          z-index: 1;
          margin: 0 auto;
        }

        .imageDeleteBtn,
        .imageEditBtn {
          position: absolute;
          bottom: 5px;
          width: 32px;
          height: 32px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
          border: 2px solid #fff;
          overflow: hidden;
          cursor: pointer;
          color: #fff;
          font-size: 14px;
        }

        .imageDeleteBtn {
          left: 5px;
          background: #f00;
        }

        .imageEditBtn {
          right: 5px;
          background: #0096c7;
        }
      }

      .customInput {
        position: relative;
        width: 100%;
        height: 132px;
        border: 2px dashed #0096c760;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;

        .inputPlaceholder {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 8px;

          .placeholderText {
            position: relative;
            font-size: 12px;
            color: #0096c7;
            margin-top: -12px;
            z-index: 2;
          }
        }

        .placeholderPhoto {
          position: relative;
          width: 84px;
          height: 84px;
          border-radius: 12px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          z-index: 1;

          svg {
            width: 100%;
            height: 100%;
            transform: scale(1.35);
          }
        }
      }
    }

    .titleInput {
      width: 100%;
      margin-bottom: 16px;

      p {
        font-family: "iranyekan", sans-serif;
        color: #000;
        font-size: 13px;
        margin-bottom: 6px;
      }

      textarea {
        width: 100%;
        border-radius: 12px;
        resize: none;
        padding: 12px;
        border: 2px solid #eee;
        font-size: 1rem;

        &:focus {
          outline: none;
          border: 2px solid #0096c7;
        }
      }

      :deep(.el-select__wrapper) {
        height: 42px;
      }
    }
  }
}

.storyOpions {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;

  .optionThumb {
    width: 100%;
    padding: 8px;
    background: #eee;
    color: #424242;
    border-radius: 8px;
    font-size: 0.8rem;
    text-align: center;
    transition: all 0.2s;
    cursor: pointer;

    &:active {
      transform: scale(0.95);
    }

    &.active {
      color: #fff;
      background: #0096c7;
      transform: scale(1.05);
    }
  }
}

@media (max-width: 400px) {
  .storyUploaderForm {
    min-width: 332px !important;
  }

  .elSelectListLabel {
    width: 228px !important;
  }
}

.storySubmitBtn {
  width: 90%;
  height: 48px;
  background: #0096c7;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #fff;
  font-family: "iranyekanB", sans-serif;
  font-size: 16px;
  margin: 0 auto;
  cursor: pointer;
}

.custom-dropdown {
  width: 333px !important; /* حداکثر عرض */
  overflow: hidden !important;
  box-sizing: border-box; /* اضافه کن که padding باعث بزرگ شدن نشه */
  padding: 0 !important; /* اگر padding داخل داره */
}

/* آیتم‌های داخل dropdown */
.custom-dropdown .el-select-dropdown__item {
  max-width: 100% !important; /* رعایت محدودیت والد */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box; /* خیلی مهم */
}

.j-modal {
  z-index: 2002 !important;
}

.elSelectListLabel {
  max-width: 312px !important;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 700px) {
  .storyUploaderForm {
    box-shadow: none !important;
    width: 100% !important;
  }
}

.dark {
  .storyOpions {
    .optionThumb {
      background: #1c2126;
      color: #fff;

      &.active {
        color: #fff;
        background: #0096c7;
        transform: scale(1.05);
      }
    }
  }
}
</style>
